const state = {
  pictureBookData: localStorage.getItem('pictureBookData') ? JSON.parse(localStorage.getItem('pictureBookData')) : ''
}

const mutations = {
  // reset all
  RESET_ALL(state, data) {
    const remove = ['pictureBookData']
    for (const key in state) {
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        if (remove.indexOf(key) > -1) {
          state[key] = data
          localStorage.removeItem(key)
        }
      }
    }
  },
  // setPictureBookData
  SET_PICTURE_BOOK_DATA(state, data) {
    state.sentenceModuleData = data
    data === ''
      ? localStorage.removeItem('pictureBookData')
      : localStorage.setItem('pictureBookData', JSON.stringify(data))
  }
}

const actions = {
  // 清除所有信息
  resetAll({ commit }) {
    return new Promise(resolve => {
      commit('RESET_ALL', '')
      resolve()
    })
  },
  // 设置句子数据
  setPictureBookData({ commit }, data) {
    commit('SET_PICTURE_BOOK_DATA', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
